'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('onyxReadingRoomApp.deviceconfigs.add', [])
  .controller('DeviceConfigsAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/deviceconfigs/add/index.js